import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { serviceGroups, site } from "../data/site";

export default function SitemapPage() {
  return (
    <>
      <SEO title="Sitemap | Polishing Singapore" description="Browse all main pages and service pages on Polishing Singapore." canonical={`${site.domain}/sitemap`} />
      <PageHero title="Sitemap" description="Main pages and material-specific polishing service pages." />
      <section className="section-pad bg-background-50">
        <div className="section-shell grid gap-8 lg:grid-cols-3">
          <div className="surface-card p-6">
            <h2 className="font-heading text-2xl font-bold">Main Pages</h2>
            <div className="mt-4 grid gap-2 text-sm font-semibold text-primary-700">
              {["/", "/about", "/services", "/portfolio", "/blog", "/faq", "/locations", "/contact"].map((path) => (
                <Link key={path} to={path}>{path === "/" ? "Home" : path}</Link>
              ))}
            </div>
          </div>
          {serviceGroups.map((group) => (
            <div key={group.slug} className="surface-card p-6">
              <h2 className="font-heading text-2xl font-bold">{group.name}</h2>
              <div className="mt-4 grid gap-2 text-sm font-semibold text-primary-700">
                {group.services.map((service) => (
                  <Link key={service.slug} to={`/services/${service.slug}`}>{service.title}</Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
